import { type RefAttributes } from 'react'
import {
	type PopoverProps as AriaPopoverProps,
	Popover as AriaPopover,
} from 'react-aria-components'
import { cx } from '#app/utils/cx'

interface PopoverProps extends AriaPopoverProps, RefAttributes<HTMLElement> {
	size: 'sm' | 'md'
}

export const Popover = (props: PopoverProps) => {
	return (
		<AriaPopover
			placement="bottom start"
			containerPadding={0}
			offset={4}
			{...props}
			className={(state) =>
				cx(
					'bg-primary ring-border-secondary_alt max-h-64! min-w-(--trigger-width) overflow-x-hidden overflow-y-auto rounded-lg py-1 shadow-lg ring-1 outline-hidden will-change-transform',

					// scrollbar styles
					// "[&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-alpha-black/15 [&::-webkit-scrollbar-track]:rounded-full [&::-webkit-scrollbar-track]:bg-primary [&::-webkit-scrollbar]:w-2",
					state.isEntering &&
						'animate-in fade-in placement-right:origin-left placement-right:slide-in-from-left-0.5 placement-top:origin-bottom placement-top:slide-in-from-bottom-0.5 placement-bottom:origin-top placement-bottom:slide-in-from-top-0.5 duration-150 ease-out',
					state.isExiting &&
						'animate-out fade-out placement-right:origin-left placement-right:slide-out-to-left-0.5 placement-top:origin-bottom placement-top:slide-out-to-bottom-0.5 placement-bottom:origin-top placement-bottom:slide-out-to-top-0.5 duration-100 ease-in',
					props.size === 'md' && 'max-h-80!',

					typeof props.className === 'function'
						? props.className(state)
						: props.className,
				)
			}
		/>
	)
}
